export interface Feed {
  id: string;
  name: string;
  running: boolean;
  type: string;
  icon?: string;
  
  getName(): string;
  getId(): string;
  isRunning(): boolean;
  start(): void;
  stop(): void;
  getIcon(): string;
}

export interface FeedType {
  id: string;
  name: string;
  icon: string;
  
  getId(): string;
  getName(): string;
  getIcon(): string;
  getWizard(): FeedWizard;
}

export interface FeedWizard {
  getPluginSteps(): WizardStep[];
  setOption(option: string, value: any): void;
  getOption(option: string): any;
  getOptions(): any;
  createFeed(name: string, options: DefaultWizardOptions, feedOptions: any): void;
}

export interface WizardStep {
  name: string;
  template: string;
  directive?: string;
}

export interface DefaultWizardOptions {
  autostart: boolean;
}
export interface FeedPlugin {
  getId(): string;
  getName(): string;
  getIcon(): string;
  getWizard(): FeedWizard;
}

function createWizardOptions(autostart: boolean): DefaultWizardOptions {
  return { autostart };
}


// models/feed.models.ts
export interface DefaultWizardOptions {
  autostart: boolean;
}

export enum FeedStates {
  LIVE = 'Live',
  RECORD = 'Recording',
  PLAYBACK = 'Recorded'
}

export interface FeedWizardStep {
  name: string;
  component: any;
}

export interface FeedPlugin {
  id: string;
  name: string;
  icon: string;
  initialize(): void;
  getWizard(): FeedWizard;
}

export interface FeedWizard {
  getPluginSteps(): FeedWizardStep[];
  createFeed(name: string, defaultOptions: DefaultWizardOptions, customOptions: any): void;
  setOption(option: string, value: any): void;
  getOption(option: string): any;
  getOptions(): any;
}

export class BaseArcliveFeed {
  id: string = '';
  name: string = '';
  icon: string = '';
  autostart: boolean = false;
  running: boolean = false;

  constructor(feedName?: string, feedIcon?: string, autostart?: boolean) {
    if (feedName) this.name = feedName;
    if (feedIcon) this.icon = feedIcon;
    if (autostart !== undefined) this.autostart = autostart;
    this.id = this.generateId();
  }

  private generateId(): string {
    return Math.random().toString(36).substring(2, 15);
  }

  initialize(): void {
    // Base implementation
  }

  start(): void {
    this.running = true;
  }

  stop(): void {
    this.running = false;
  }

  setName(name: string): void {
    this.name = name;
  }

  getName(): string {
    return this.name;
  }

  setIcon(icon: string): void {
    this.icon = icon;
  }

  getIcon(): string {
    return this.icon;
  }

  setAutoStarted(autostart: boolean): void {
    this.autostart = autostart;
  }

  isAutoStarted(): boolean {
    return this.autostart;
  }

  setId(id: string): void {
    this.id = id;
  }

  getId(): string {
    return this.id;
  }

  isRunning(): boolean {
    return this.running;
  }
}

export class FmvFeed extends BaseArcliveFeed {
  ipAddr: string = '';
  videoType: string = '';
  state: FeedStates = FeedStates.LIVE;
  archiveFeed: boolean = true;

  constructor(
    feedName?: string, 
    feedIcon?: string, 
    autostart?: boolean, 
    ipAddr?: string, 
    videoType?: string, 
    archiveFeed?: boolean
  ) {
    super(feedName, feedIcon, autostart);
    if (ipAddr) this.ipAddr = ipAddr;
    if (videoType) this.videoType = videoType;
    if (archiveFeed !== undefined) this.archiveFeed = archiveFeed;
  }

  setIpAddr(ipAddr: string): void {
    this.ipAddr = ipAddr;
  }

  getIpAddr(): string {
    return this.ipAddr;
  }

  setVideoType(videoType: string): void {
    this.videoType = videoType;
  }

  getVideoType(): string {
    return this.videoType;
  }

  setFeedState(feedState: FeedStates): void {
    this.state = feedState;
  }

  getFeedState(): FeedStates {
    return this.state;
  }

  shouldArchive(): boolean {
    return this.archiveFeed;
  }

  toJson(): any {
    return {
      FmvFeed: {
        id: this.id,
        name: this.name,
        icon: this.icon,
        autostart: this.autostart,
        ipAddr: this.ipAddr,
        videoType: this.videoType,
        running: this.running,
        state: this.state,
        archiveFeed: this.archiveFeed
      }
    };
  }

  fromJson(json: any): void {
    this.setName(json.name);
    this.setIcon(json.icon);
    this.setAutoStarted(json.autostart);
    this.setIpAddr(json.ipAddr);
    this.setVideoType(json.videoType);
    this.setId(json.id);
    this.setFeedState(FeedStates.LIVE);

    if (json.running) {
      this.start();
    }
  }
}